import React, { useState } from 'react'
import { Button } from '@mui/material'
import Spacer from '../../common/components/Spacer'
import EditIcon from '../../common/icons/editIcon'
import ActionButtons from '../../common/components/ActionButtons'
import DeleteDialog from '../../common/components/DeleteDialog'
import CreateTopicModal from './CreateTopicModal'
import { ReactComponent as TextIcon } from '../../common/icons/text-_icon.svg'
import { useDeleteTrainingTopicMutation } from '../../api/trainingTopics'
import useMutation from '../../hooks/useMutation'
import PlusIcon from '../../common/icons/plusIcon'
import DeleteIcon from '../../common/icons/deleteIcon'
import { useNavigate } from 'react-router-dom'
import { AiPowerIcon } from 'src/common/icons/aiPower'

export default function MicroTrainingCard({ item, onSelect, onGenerateClick }) {
  const { topic, type, activeModules, trainingId } = item
  const activeModulesCount = activeModules?.length || 0
  const visibleModules = activeModules?.slice(0, 4) || []
  const hiddenModulesCount = activeModulesCount > 4 ? activeModulesCount - 4 : 0
  const isCustom = type === 'CUSTOM'
  const navigate = useNavigate()

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)

  const { submit: handleDelete, refetch } = useMutation(useDeleteTrainingTopicMutation, {
    successMessage: 'Topic successfully deleted',
    onSuccess: () => {
      setIsDeleteDialogOpen(false)
    }
  })

  const handleAddModule = () => {
    navigate(`/topics/${trainingId}/modules/create`)
  }

  const actionConfig = [
    {
      name: 'Rename',
      icon: <TextIcon style={{ width: 20, height: 20 }} />,
      onClick: () => setIsEditModalOpen(true)
    },
    {
      name: 'Add Module',
      icon: <PlusIcon color={'#ffffff'} style={{ width: 20, height: 20 }} />,
      onClick: handleAddModule
    },
    {
      name: 'Generate Module',
      icon: <AiPowerIcon color={'#ffffff'} style={{ width: 20, height: 20 }} />,
      onClick: onGenerateClick
    },
    {
      name: 'Delete',
      icon: <DeleteIcon color={'#FFFFFF'} />,
      onClick: () => setIsDeleteDialogOpen(true)
    }
  ]

  return (
    <div className='micro-training-item column'>
      <div
        className={`micro-training-item-rb ${isCustom ? 'micro-training-item-rb-violet' : 'micro-training-item-rb-green'}`}
      ></div>

      <div className='row'>
        <p className='micro-training-item-title'>{topic}</p>
        <Spacer />
        <ActionButtons isHidden={!isCustom} config={actionConfig} />
      </div>

      <p className='active-modules-count'>
        {activeModulesCount}
        <span className='active-modules-label'>active modules</span>
      </p>

      <div className='column' style={{ maxHeight: 120, overflow: 'hidden' }}>
        {visibleModules.map(el => (
          <p key={el} className='module-name'>
            {el}
          </p>
        ))}
      </div>

      {hiddenModulesCount > 0 && <p className='more-modules'>+ {hiddenModulesCount} more</p>}

      <Spacer />

      <Button
        onClick={onSelect}
        className='view-modules-button'
        sx={{ color: '#6123FF', borderColor: '#E7E7EE', textTransform: 'none', height: '60px' }}
        startIcon={<EditIcon />}
        fullWidth
        variant='outlined'
      >
        View Modules
      </Button>

      {isDeleteDialogOpen && (
        <DeleteDialog
          open={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
          onAction={() => handleDelete({ id: trainingId })}
          str={topic}
          description='This topic and all its modules will be deleted permanently.'
        />
      )}

      {isEditModalOpen && (
        <CreateTopicModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          rowData={{ name: topic, id: trainingId }}
        />
      )}
    </div>
  )
}
